import React from "react";
import styles from "./BenefitBlockWrapper.module.css";

const BenefitBlockWrapper = ({ children }) => {
  return <div className={styles.wrapper}>{children}</div>;
};

export default BenefitBlockWrapper;
